import React from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon, ArrowRightIcon, ShieldIcon } from 'lucide-react';
import { SEO } from '../../components/SEO';
export const OntchromenPage = () => {
  return <main data-id="element-1140">
      <SEO title="Auto Ontchromen Almere | Chrome Delete | BKCustoms" description="Professioneel auto ontchromen in Almere vanaf €75. Chrome delete voor een moderne, strakke look. Niet-permanente modificatie met hoogwaardige vinyl bij BKCustoms." canonical="/diensten/ontchromen" data-id="element-1141" />
      {/* Header Banner */}
      <div className="relative bg-[#0a0a0a] py-28" data-id="element-1142">
        <div className="absolute inset-0 overflow-hidden" data-id="element-1143">
          <div className="absolute inset-0 bg-black/80 z-10" data-id="element-1144"></div>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8h8EqFfY6iTr2pX1pd2aXy/AS_Dechrome_Hero-768x512.jpg" alt="Auto ontchromen in Almere" className="w-full h-full object-cover object-center" data-id="element-1145" />
        </div>
        <div className="relative z-20 max-w-7xl mx-auto px-6 lg:px-8 text-center" data-id="element-1146">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-1147">
            <span className="text-[#D6281F]" data-id="element-1148">Auto Ontchromen Almere</span> -
            Voor een strakke, moderne look
          </h1>
          <p className="text-white/80 max-w-2xl mx-auto text-lg mb-4" data-id="element-1149">
            Transformeer je auto in Almere met onze professionele ontchroom
            service. Vervang glanzende chrome elementen voor stijlvolle matte of
            glanzende zwarte accenten. Vanaf slechts €75.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4 mt-8" data-id="element-1150">
            <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide inline-flex items-center justify-center" data-id="element-1151">
              <span className="mr-2" data-id="element-1152">Direct afspraak maken</span>
              <ArrowRightIcon size={16} data-id="element-1153" />
            </Link>
            <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10 inline-flex items-center justify-center" data-id="element-1154">
              Offerte aanvragen
            </Link>
          </div>
        </div>
      </div>
      {/* Service Description Section */}
      <section className="bg-[#0a0a0a] py-20" data-id="element-1155">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1156">
          <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-1157">
            {/* Image Section */}
            <div className="w-full lg:w-1/2" data-id="element-1158">
              <div className="relative" data-id="element-1159">
                <div className="absolute -inset-4 bg-gradient-to-tr from-[#D6281F] via-[#FF6B00] to-[#FFD500] opacity-30 blur-lg rounded-lg" data-id="element-1160"></div>
                <div className="relative overflow-hidden rounded-lg border border-white/10 shadow-2xl" data-id="element-1161">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8h8EqFfY6iTr2pX1pd2aXy/AS_Dechrome_Hero-768x512.jpg" alt="Auto ontchromen voorbeeld in Almere" className="w-full h-auto object-cover" data-id="element-1162" />
                </div>
              </div>
            </div>
            {/* Content Section */}
            <div className="w-full lg:w-1/2" data-id="element-1163">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-1164">
                Auto Ontchromen Almere - Vanaf €75
              </h2>
              <p className="text-white/80 text-lg mb-6 leading-relaxed" data-id="element-1165">
                Auto ontchromen, ook wel bekend als 'Chrome Delete', is een
                populaire styling techniek waarbij glanzende chrome elementen
                worden vervangen door matte of glanzende zwarte accenten. Dit
                geeft jouw auto een moderne, sportieve en onderscheidende
                uitstraling.
              </p>
              <p className="text-white/80 text-lg mb-8 leading-relaxed" data-id="element-1166">
                Bij BKCustoms in Almere gebruiken we hoogwaardige wrapping
                materialen om chromen elementen zoals raamlijsten, grilles,
                emblemen en andere accenten te transformeren, zonder de
                originele onderdelen te beschadigen.
              </p>
              <div className="space-y-4 mb-8" data-id="element-1167">
                <div className="flex items-center" data-id="element-1168">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-1169">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-1170" />
                  </div>
                  <span className="text-white/90" data-id="element-1171">
                    Niet-permanente modificatie
                  </span>
                </div>
                <div className="flex items-center" data-id="element-1172">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-1173">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-1174" />
                  </div>
                  <span className="text-white/90" data-id="element-1175">
                    Hoogwaardige vinyl materialen
                  </span>
                </div>
                <div className="flex items-center" data-id="element-1176">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-1177">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-1178" />
                  </div>
                  <span className="text-white/90" data-id="element-1179">
                    Bescherming van originele onderdelen
                  </span>
                </div>
                <div className="flex items-center" data-id="element-1180">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-1181">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-1182" />
                  </div>
                  <span className="text-white/90" data-id="element-1183">
                    Keuze uit matte of glanzende afwerking
                  </span>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-1184">
                <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide inline-flex items-center justify-center" data-id="element-1185">
                  <span className="mr-2" data-id="element-1186">Afspraak maken</span>
                  <ArrowRightIcon size={16} data-id="element-1187" />
                </Link>
                <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10 inline-flex items-center justify-center" data-id="element-1188">
                  Offerte aanvragen
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* What We Offer Section */}
      <section className="bg-[#0f0f0f] py-20" data-id="element-1189">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1190">
          <div className="text-center mb-16" data-id="element-1191">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-1192">
              Auto Ontchromen in <span className="text-[#D6281F]" data-id="element-1193">Almere</span>
            </h2>
            <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-1194">
              Bij BKCustoms in Almere kunnen we diverse chrome elementen van je
              auto vervangen door stijlvolle zwarte accenten
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1195">
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg" data-id="element-1196">
              <div className="bg-[#D6281F]/20 p-3 rounded-full inline-block mb-4" data-id="element-1197">
                <ShieldIcon size={24} className="text-[#D6281F]" data-id="element-1198" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-1199">Raamlijsten</h3>
              <p className="text-white/80" data-id="element-1200">
                Vervang glanzende chrome raamlijsten door elegante zwarte
                accenten voor een sportieve, moderne uitstraling.
              </p>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg" data-id="element-1201">
              <div className="bg-[#D6281F]/20 p-3 rounded-full inline-block mb-4" data-id="element-1202">
                <ShieldIcon size={24} className="text-[#D6281F]" data-id="element-1203" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-1204">
                Grilles & Emblemen
              </h3>
              <p className="text-white/80" data-id="element-1205">
                Transformeer je grille en emblemen naar stijlvolle zwarte
                accenten voor een unieke, onderscheidende look.
              </p>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg" data-id="element-1206">
              <div className="bg-[#D6281F]/20 p-3 rounded-full inline-block mb-4" data-id="element-1207">
                <ShieldIcon size={24} className="text-[#D6281F]" data-id="element-1208" />
              </div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-1209">
                Complete Chrome Delete
              </h3>
              <p className="text-white/80" data-id="element-1210">
                Voor maximale impact bieden we een volledige chrome delete voor
                alle chromen elementen op je auto.
              </p>
            </div>
          </div>
          <div className="mt-12 text-center" data-id="element-1211">
            <p className="text-white/70 text-lg" data-id="element-1212">
              Auto ontchromen in Almere vanaf €75, afhankelijk van het type auto
              en de hoeveelheid chrome elementen.
              <br data-id="element-1213" />
              Neem contact met ons op voor een persoonlijke offerte.
            </p>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="bg-[#0a0a0a] py-16 border-t border-[#222]" data-id="element-1214">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center" data-id="element-1215">
          <h2 className="text-3xl font-bold text-white mb-6" data-id="element-1216">
            Klaar voor een moderne look met auto ontchromen in Almere?
          </h2>
          <p className="text-white/80 mb-8" data-id="element-1217">
            Neem contact met ons op voor een persoonlijk advies of maak direct
            een afspraak voor jouw auto bij BKCustoms in Almere.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-1218">
            <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-8 py-4 rounded-md transition-all duration-300 font-medium tracking-wide" data-id="element-1219">
              Afspraak maken
            </Link>
            <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-8 py-4 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10" data-id="element-1220">
              Contact opnemen
            </Link>
          </div>
        </div>
      </section>
    </main>;
};